/* eslint-disable */
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    TextField,
    Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Controls } from '../../components/controls/Controls';
import { Form, useForm } from '../../components/useForm';
import { setSnackbar } from '../../redux/ducks/snackbar';
import http from '../../http-common';

const STATUS_OPTIONS = [
    { id: 'PENDIENTE', title: 'Pendiente' },
    { id: 'TIMBRADO', title: 'Timbrado' },
    { id: 'CANCELADO', title: 'Cancelado' },
];

const initialFieldValues = {
    id: 0,
    fecha: null,
    monto: 0,
    banco: '',
    factura: '',
    cliente: '',
    folioComplementoPago: '',
    statusComplemento: 'PENDIENTE',
    comentarios: '',
    idMovimientosBancarios: '',
    idCuentaBancaria: '',
};

export default function ControlIngresosForm(props) {
    const { addOrEdit, recordForEdit } = props;
    const dispatch = useDispatch();

    const [unapproveDialogOpen, setUnapproveDialogOpen] = useState(false);
    const [unapprovePassword, setUnapprovePassword] = useState('');
    const [pendingValues, setPendingValues] = useState(null);

    const {
        values,
        setValues,
        errors,
        setErrors,
        handleInputChange,
        resetForm,
    } = useForm(initialFieldValues, true, validate);

    function validate(fieldValues = values) {
        const temp = { ...errors };
        if ('fecha' in fieldValues) temp.fecha = fieldValues.fecha ? '' : 'Campo requerido';
        if ('monto' in fieldValues) temp.monto = fieldValues.monto !== '' && fieldValues.monto !== null ? '' : 'Campo requerido';
        if ('cliente' in fieldValues) temp.cliente = fieldValues.cliente ? '' : 'Campo requerido';
        setErrors({ ...temp });
        if (fieldValues === values) return Object.values(temp).every((x) => x === '');
        return true;
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        // Validar campos requeridos con mensaje claro
        const f = values.fecha;
        const fechaValida = f && !(f instanceof Date && Number.isNaN(f.getTime()));
        if (!fechaValida && !values.cliente) {
            dispatch(setSnackbar(true, 'error', 'Los campos Fecha y Cliente son requeridos'));
            return;
        }
        if (!fechaValida) {
            dispatch(setSnackbar(true, 'error', 'El campo Fecha es requerido'));
            return;
        }
        if (!values.cliente) {
            dispatch(setSnackbar(true, 'error', 'El campo Cliente es requerido'));
            return;
        }

        if (!validate()) return;

        // Si el registro ya está APROBADO, pedir password antes de guardar
        if (recordForEdit?.status === 'APROBADO') {
            setPendingValues(values);
            setUnapproveDialogOpen(true);
            return;
        }

        addOrEdit(values, resetForm);
    };

    const handleUnapproveAndSave = async () => {
        let resp;
        try {
            resp = await http.post('/control-ingresos/aprobarIngreso', [
                { id: pendingValues.id, status: 'PENDIENTE', password: unapprovePassword },
            ], { validateStatus: () => true });
        } catch {
            resp = null;
        }
        if (!resp || resp.status < 200 || resp.status >= 300) {
            const msg = typeof resp?.data === 'string' ? resp.data : resp?.data?.message;
            dispatch(setSnackbar(true, 'error', msg || 'Error al des-aprobar el ingreso'));
            return;
        }
        addOrEdit({ ...pendingValues, status: 'PENDIENTE' }, resetForm);
        setUnapproveDialogOpen(false);
        setUnapprovePassword('');
        setPendingValues(null);
    };

    useEffect(() => {
        if (recordForEdit != null) {
            const fechaNormalizada = (typeof recordForEdit.fecha === 'string' && !recordForEdit.fecha.includes('T'))
                ? new Date(`${recordForEdit.fecha}T00:00:00`)
                : recordForEdit.fecha;
            setValues({ ...recordForEdit, fecha: fechaNormalizada });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [recordForEdit]);

    return (
        <>
            <Form onSubmit={handleSubmit}>
                <Grid container>
                    <Grid item xs={6}>
                        <Controls.DatePicker
                            disabled={!!values.idMovimientosBancarios}
                            error={errors.fecha}
                            label='Fecha'
                            name='fecha'
                            onChange={handleInputChange}
                            value={values.fecha}
                        />
                        {!!values.idMovimientosBancarios && (
                            <Typography sx={{ color: 'text.secondary', fontSize: '0.75rem', mb: 1, mt: -0.5, px: 1 }}>
                                La fecha debe modificarse en Movimientos Bancarios
                            </Typography>
                        )}
                        <Controls.Input
                            error={errors.cliente}
                            label='Cliente'
                            name='cliente'
                            onChange={handleInputChange}
                            value={values.cliente}
                        />
                        <Controls.Input
                            disabled={!!values.idMovimientosBancarios}
                            error={errors.monto}
                            inputProps={{ step: '0.01' }}
                            label='Monto'
                            name='monto'
                            onChange={handleInputChange}
                            sx={{
                                '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': { display: 'none' },
                                '& input[type=number]': { MozAppearance: 'textfield' },
                                '& .MuiOutlinedInput-root': !!values.idMovimientosBancarios ? { backgroundColor: '#f5f5f5' } : {},
                            }}
                            type='number'
                            value={values.monto}
                        />
                        <Controls.Input
                            label='Banco'
                            name='banco'
                            onChange={handleInputChange}
                            value={values.banco}
                        />
                        <Controls.Input
                            helperText={`${(values.factura || '').length}/1500`}
                            inputProps={{ maxLength: 1500 }}
                            label='Factura'
                            multiline
                            name='factura'
                            onChange={handleInputChange}
                            rows={3}
                            value={values.factura}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Controls.Input
                            label='Folio Complemento de Pago'
                            name='folioComplementoPago'
                            onChange={handleInputChange}
                            value={values.folioComplementoPago}
                        />
                        <Controls.Select
                            label='Status Complemento'
                            name='statusComplemento'
                            onChange={handleInputChange}
                            options={STATUS_OPTIONS}
                            value={values.statusComplemento}
                        />
                        <Controls.Input
                            inputProps={{ readOnly: true, step: '1' }}
                            label='ID Movimiento Bancario'
                            name='idMovimientosBancarios'
                            onChange={() => {}}
                            sx={{
                                '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': { display: 'none' },
                                '& input[type=number]': { MozAppearance: 'textfield' },
                                '& .MuiOutlinedInput-root': { backgroundColor: '#f5f5f5' },
                            }}
                            type='number'
                            value={values.idMovimientosBancarios}
                        />
                        <Controls.Input
                            disabled
                            label='ID Cuenta Bancaria'
                            name='idCuentaBancaria'
                            onChange={() => {}}
                            sx={{ '& .MuiOutlinedInput-root': { backgroundColor: '#f5f5f5' } }}
                            value={values.idCuentaBancaria || ''}
                        />
                        <Controls.Textarea
                            label='Comentarios'
                            maxRows={4}
                            minRows={3}
                            name='comentarios'
                            onChange={handleInputChange}
                            value={values.comentarios}
                        />
                        <div>
                            <Controls.Button
                                text='Guardar'
                                type='submit'
                            />
                            <Controls.Button
                                color='default'
                                onClick={resetForm}
                                text='Reset'
                            />
                        </div>
                    </Grid>
                </Grid>
            </Form>

            {/* Diálogo de des-aprobación con password */}
            <Dialog onClose={() => setUnapproveDialogOpen(false)} open={unapproveDialogOpen}>
                <DialogTitle>Ingreso APROBADO</DialogTitle>
                <DialogContent>
                    <Typography
                        sx={{ mb: 2, color: '#c62828', fontWeight: 'bold' }}
                        variant='body2'
                    >
                        Este registro ya está APROBADO. Necesitas introducir el password si quieres
                        editarlo. Al editarlo YA NO ESTARÁ APROBADO.
                    </Typography>
                    <TextField
                        autoFocus
                        fullWidth
                        label='Password'
                        margin='dense'
                        onChange={(e) => setUnapprovePassword(e.target.value)}
                        onKeyDown={(e) => { if (e.key === 'Enter' && unapprovePassword) handleUnapproveAndSave(); }}
                        type='password'
                        value={unapprovePassword}
                    />
                </DialogContent>
                <DialogActions>
                    <Controls.Button
                        color='default'
                        onClick={() => {
                            setUnapproveDialogOpen(false);
                            setUnapprovePassword('');
                            setPendingValues(null);
                        }}
                        text='Cancelar'
                        variant='outlined'
                    />
                    <Controls.Button
                        disabled={!unapprovePassword}
                        onClick={handleUnapproveAndSave}
                        text='Confirmar y Guardar'
                    />
                </DialogActions>
            </Dialog>
        </>
    );
}
